// extracted by mini-css-extract-plugin
export default {"followButton":"GF-z","followCount":"HF-z","textStyle":"IF-z"};